// @spec BCP-STR-051
import { createFileRoute } from '@tanstack/react-router';

import { Nis2ComplianceReportPage } from '@/features/bcp/components/Nis2ComplianceReportPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp/reports/nis2-compliance')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.nis2ComplianceReport'),
  }),
  component: Nis2ComplianceReportRoute,
});

function Nis2ComplianceReportRoute() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <Nis2ComplianceReportPage />
      </div>
    </div>
  );
}
